import state from "@/store/var/state";

export default {
    state
}